// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export * from "./bytesEncoding.common.js";
